<ng-template #companySelectModal let-modal>
  <div class="modal-header" style="padding: 10px;">
    <h6 class="modal-title" id="modal-basic-title" style="margin-top: 0px;">Select Company</h6>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('close')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" style="font-size: 12px;">
    <section class="company-list-container">
      <app-data-table [columns]="columns" [loadPage]="loadPage" [(filters)]="filters" [pageSize]="20"
        [filtersComponent]="dataFilters" (onTableRowClick)="onTableRowClickEvent($event)">
        <app-data-filters #dataFilters>
          <app-data-filter-group>
            <app-data-filter-input [label]="'client-list.id.label' | translate" [(model)]="filters.id"
              [placeholder]="'client-list.id.placeholder' | translate"></app-data-filter-input>
            <app-data-filter-input [label]="'client-list.firstName.label' | translate" [(model)]="filters.firstName"
              [placeholder]="'client-list.firstName.placeholder' | translate"></app-data-filter-input>
            <app-data-filter-input [label]="'client-list.lastName.label' | translate" [(model)]="filters.lastName"
              [placeholder]="'client-list.lastName.placeholder' | translate"></app-data-filter-input>
            <app-data-filter-input [label]="'client-list.company.label' | translate" [(model)]="filters.company"
              [placeholder]="'client-list.company.placeholder' | translate"></app-data-filter-input>
            <app-data-filter-input [label]="'client-list.address.label' | translate" [(model)]="filters.address"
              [placeholder]="'client-list.address.placeholder' | translate"></app-data-filter-input>
          </app-data-filter-group>
        </app-data-filters>
      </app-data-table>
    </section>
  </div>
  <div class="modal-footer">
    <button class="btn btn-sm btn-primary" (click)="modal.dismiss('close')">Close</button>
  </div>
</ng-template>

<!-- <button class="btn btn-sm btn-primary" style="margin:0px;" (click)="open(priceListPreview)" [disabled]="disabled">Details</button> -->
<div class="form-group">
  <label class="control-label" *ngIf="showLabel">Search Company</label>
  <div class="input-group input-group-sm">
    <input type="text" class="form-control" placeholder="Search Company" disabled="disabled" [(ngModel)]="companyName">
    <div class="input-group-append">
      <button class="btn btn-outline-secondary" type="button" (click)="openModal(companySelectModal)"><i
          class="fa fa-search"></i></button>
    </div>
  </div>
</div>



<ng-template #idColumn let-id="id">
  {{id}}
</ng-template>

<ng-template #firstNameColumn let-firstName="firstName">
  {{firstName}}
</ng-template>

<ng-template #lastNameColumn let-lastName="lastName">
  {{lastName}}
</ng-template>

<ng-template #emailColumn let-email="firstEmail">
  {{email}}
</ng-template>

<ng-template #companyColumn let-company="company">
  <span *ngIf="company"> {{company.name}} </span>
</ng-template>

<ng-template #addressColumn let-company="company">
  <span *ngIf="company.address"> {{company.address}} </span>
</ng-template>

<ng-template #actionsColumn let-id="id">
  {{id}}
</ng-template>